var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripfive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 28,
    viewBox: "0 0 44 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1374_12929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 30,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3H36.5V25H7.5V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1374_12929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 20.562C36.5 23.0158 34.4803 25.0054 31.9889 25.0054H7.5V7.44332C7.5 4.9894 9.51974 3 12.0114 3H36.5V20.562Z",
    fill: "#FFFFFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1374_12929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 14,
    width: 4,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5156 16.0627H30.3808C30.4394 16.0627 30.5504 16.0535 30.6032 16.0421C30.9612 15.9658 31.2594 15.6527 31.2594 15.2262C31.2594 14.7996 30.9612 14.4857 30.6032 14.4094C30.5504 14.398 30.4394 14.3887 30.3808 14.3887H28.5156V16.0627Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1374_12929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5156 16.0627H30.3808C30.4394 16.0627 30.5504 16.0535 30.6032 16.0421C30.9612 15.9658 31.2594 15.6527 31.2594 15.2262C31.2594 14.7996 30.9612 14.4857 30.6032 14.4094C30.5504 14.398 30.4394 14.3887 30.3808 14.3887H28.5156V16.0627Z",
    fill: "url(#paint0_linear_1374_12929)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1374_12929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 4,
    width: 9,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.163 4.48117C28.3835 4.48117 26.9407 5.90214 26.9407 7.6548V10.9513H31.5001C31.6058 10.9513 31.7351 10.9586 31.8158 10.9627C32.8476 11.0137 33.6086 11.5358 33.6086 12.4419C33.6086 13.1544 33.0885 13.7627 32.1419 13.8998V13.9355C33.1876 14.007 33.9881 14.5737 33.9881 15.4669C33.9881 16.433 33.1094 17.0541 31.9381 17.0541H26.9407V23.5241H31.6668C33.4463 23.5241 34.889 22.1031 34.889 20.3503V4.48117H30.163Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1374_12929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.163 4.48117C28.3835 4.48117 26.9407 5.90214 26.9407 7.6548V10.9513H31.5001C31.6058 10.9513 31.7351 10.9586 31.8158 10.9627C32.8476 11.0137 33.6086 11.5358 33.6086 12.4419C33.6086 13.1544 33.0885 13.7627 32.1419 13.8998V13.9355C33.1876 14.007 33.9881 14.5737 33.9881 15.4669C33.9881 16.433 33.1094 17.0541 31.9381 17.0541H26.9407V23.5241H31.6668C33.4463 23.5241 34.889 22.1031 34.889 20.3503V4.48117H30.163Z",
    fill: "url(#paint1_linear_1374_12929)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1374_12929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 11,
    width: 4,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0385 12.6715C31.0385 12.2522 30.7403 11.9711 30.3898 11.9127C30.357 11.9071 30.2677 11.8987 30.2063 11.8987H28.5156V13.4439H30.2063C30.2677 13.4439 30.357 13.4352 30.3898 13.4297C30.7403 13.3713 31.0385 13.0904 31.0385 12.6715Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1374_12929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0385 12.6715C31.0385 12.2522 30.7403 11.9711 30.3898 11.9127C30.357 11.9071 30.2677 11.8987 30.2063 11.8987H28.5156V13.4439H30.2063C30.2677 13.4439 30.357 13.4352 30.3898 13.4297C30.7403 13.3713 31.0385 13.0904 31.0385 12.6715Z",
    fill: "url(#paint2_linear_1374_12929)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1374_12929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3335 4.48117C10.5539 4.48117 9.11133 5.90214 9.11133 7.6548V15.4928C10.015 15.924 10.9486 16.2049 11.8989 16.2049C13.0129 16.2049 13.625 15.5351 13.625 14.6337V10.9514H16.3963V14.6337C16.3963 16.074 15.4987 17.2291 12.4187 17.2291C10.5651 17.2291 9.11133 16.8354 9.11133 16.8354V23.5241H13.8373C15.6168 23.5241 17.0595 22.1031 17.0595 20.3503V4.48117H12.3335Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1374_12929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3335 4.48117C10.5539 4.48117 9.11133 5.90214 9.11133 7.6548V15.4928C10.015 15.924 10.9486 16.2049 11.8989 16.2049C13.0129 16.2049 13.625 15.5351 13.625 14.6337V10.9514H16.3963V14.6337C16.3963 16.074 15.4987 17.2291 12.4187 17.2291C10.5651 17.2291 9.11133 16.8354 9.11133 16.8354V23.5241H13.8373C15.6168 23.5241 17.0595 22.1031 17.0595 20.3503V4.48117H12.3335Z",
    fill: "url(#paint3_linear_1374_12929)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1374_12929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 8,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2483 4.48117C19.4687 4.48117 18.0261 5.90214 18.0261 7.6548V11.81C18.8426 11.1201 20.2544 10.6891 22.5482 10.7908C23.7761 10.8447 25.0781 11.1691 25.0781 11.1691V12.5129C24.4264 12.1876 23.6449 11.8863 22.638 11.8111C20.8971 11.6816 19.8495 12.5196 19.8495 14.0029C19.8495 15.4858 20.8971 16.3236 22.638 16.1934C23.6449 16.119 24.4367 15.8096 25.0781 15.4926V16.8357C25.0781 16.8357 23.7761 17.1599 22.5482 17.2148C20.2544 17.3165 18.8426 16.8856 18.0261 16.1957V23.5241H22.7521C24.5315 23.5241 25.9741 22.1031 25.9741 20.3503V4.48117H21.2483Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1374_12929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2483 4.48117C19.4687 4.48117 18.0261 5.90214 18.0261 7.6548V11.81C18.8426 11.1201 20.2544 10.6891 22.5482 10.7908C23.7761 10.8447 25.0781 11.1691 25.0781 11.1691V12.5129C24.4264 12.1876 23.6449 11.8863 22.638 11.8111C20.8971 11.6816 19.8495 12.5196 19.8495 14.0029C19.8495 15.4858 20.8971 16.3236 22.638 16.1934C23.6449 16.119 24.4367 15.8096 25.0781 15.4926V16.8357C25.0781 16.8357 23.7761 17.1599 22.5482 17.2148C20.2544 17.3165 18.8426 16.8856 18.0261 16.1957V23.5241H22.7521C24.5315 23.5241 25.9741 22.1031 25.9741 20.3503V4.48117H21.2483Z",
    fill: "url(#paint4_linear_1374_12929)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1374_12929",
    x1: 26.9407,
    y1: 17.6565,
    x2: 34.9094,
    y2: 17.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FB345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1374_12929",
    x1: 26.9407,
    y1: 23.5488,
    x2: 34.9096,
    y2: 23.5488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FB345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1374_12929",
    x1: 26.9405,
    y1: 15.1116,
    x2: 34.909,
    y2: 15.1116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FB345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1374_12929",
    x1: 9.10101,
    y1: 23.6964,
    x2: 17.193,
    y2: 23.6964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2E61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1374_12929",
    x1: 17.9785,
    y1: 23.4176,
    x2: 25.8375,
    y2: 23.4176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D91F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613033"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripfive);
export default __webpack_public_path__ + "static/media/stripfive.2ef5198c7fffd6ee50954cab944271a5.svg";
export { ForwardRef as ReactComponent };